<template>
  <b-modal
    :id="id"
    modal-class="guide-modal"
    size="lg"
    hide-footer
    hide-header
    centered
  >
    <div
      class="close-vimeo"
      @click="$bvModal.hide(id)"
      :class="showThumbnail ? 'close-img' : 'close-video'"
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="16" cy="16" r="16" fill="white" />
        <g clip-path="url(#clip0)">
          <path
            d="M16.7857 16.0008L22.9484 9.83807C23.1654 9.6211 23.1654 9.26932 22.9484 9.05238C22.7315 8.83543 22.3797 8.83541 22.1627 9.05238L16 15.2151L9.83734 9.05238C9.62037 8.83541 9.26859 8.83541 9.05164 9.05238C8.8347 9.26935 8.83467 9.62113 9.05164 9.83807L15.2143 16.0008L9.05164 22.1635C8.83467 22.3804 8.83467 22.7322 9.05164 22.9492C9.16012 23.0576 9.30231 23.1119 9.44451 23.1119C9.5867 23.1119 9.72887 23.0576 9.83737 22.9492L16 16.7865L22.1627 22.9492C22.2712 23.0576 22.4134 23.1119 22.5556 23.1119C22.6978 23.1119 22.8399 23.0576 22.9484 22.9492C23.1654 22.7322 23.1654 22.3804 22.9484 22.1635L16.7857 16.0008Z"
            fill="#606770"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect
              width="14.2222"
              height="14.2222"
              fill="white"
              transform="translate(8.88892 8.88892)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
    <img v-if="showThumbnail" :src="videoThumb" alt="Video Thumbnail" />
    <!--    <vue-vimeo-player-->
    <!--      v-show="playerReady"-->
    <!--      class="player"-->
    <!--      ref="player"-->
    <!--      :video-id="videoId"-->
    <!--      @ready="onReady"-->
    <!--      :player-height="520"-->
    <!--      :player-width="700"-->
    <!--    >-->
    <!--    </vue-vimeo-player>-->
    <Player v-show="playerReady" :id="videoId" type="vimeo" />
  </b-modal>
</template>

<script>
// import { vueVimeoPlayer } from "vue-vimeo-player";
import Player from "../player";
export default {
  components: {
    // vueVimeoPlayer,
    Player
  },
  data() {
    return {
      playerReady: false,
      showThumbnail: true
    };
  },
  props: ["id", "videoId", "videoThumb"],
  mounted() {
    if (this.videoId) {
      this.onReady();
    }
  },
  methods: {
    onReady() {
      this.showThumbnail = false;
      this.playerReady = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.guide-modal___BV_modal_content_ {
  border-radius: 16px;
}
.close-vimeo {
  position: absolute;
  right: 0;
  cursor: pointer;
}
.close-img {
  top: 0;
}
.close-video {
  top: 61px;
}
.player {
  margin-left: 33px;
}
</style>
<style lang="scss">
#guide-video___BV_modal_content_,
#tool-video___BV_modal_content_,
#focus-tool-video___BV_modal_content_,
#blogger-video___BV_modal_content_,
#guide-help-video___BV_modal_content_,
#blogger-article-video___BV_modal_content_,
#plan-video___BV_modal_content_ {
  width: auto;
  background: none;
  border: none;
}
</style>
